<template>
  <div v-if="research">
    <v-research-edit
      :research="research"
      @research-submitted="$router.push({ name: 'organisation-research-list' })"
      @research-updated="fetchResearch"
    />
  </div>
  <div v-else class="pt-5 text-center">
    <div class="mb-3">{{ $t('sentence.please_wait_data_loaded') }}</div>
    <v-loader/>
  </div>
</template>

<script>
import Loader from '@/common/components/Loader.vue';
import ResearchEdit from '@/organisation/components/research/ResearchEdit.vue';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import { mapGetters } from 'vuex';
import { CLICKABLE_STATUSES } from '@/organisation/services/researches';
import { pageNotFound } from '@/common/utils/notify';

export default {
  name: 'ResearchEditView',
  components: {
    'v-loader': Loader,
    'v-research-edit': ResearchEdit,
  },
  computed: {
    ...mapGetters('researches', [
      'research',
      'researchItems',
    ]),
  },
  methods: {
    async fetchResearch() {
      await this.$store.dispatch('researches/fetchResearch', this.$route.params.uuid);
      if (!this.research || !CLICKABLE_STATUSES.includes(this.research.status)) {
        pageNotFound();
        await this.$router.push({ name: 'organisation-research-list' });
        return;
      }
      if (this.research.status !== 'draft') {
        await this.$router.push({ name: 'organisation-research-dashboard', params: { uuid: this.research.uuid } });
        return;
      }
      setBreadcrumbs('organisation.researchDetail', [this.research.title]);
    },
  },
  created() {
    if (!this.research || this.research.uuid !== this.$route.params.uuid) {
      this.fetchResearch();
    }
  },
};
</script>
